import { LayoutComposer, PageScroll } from '@accedo/page';
import { ComponentType } from 'preact';
import { ComponentTypes, ComponentTypesUnion } from '##/utils/types';
import { addPageScroll } from '../../../page-plugins';
import { SideNav } from '../SideNav/SideNav';
import { HomeMarquee } from '../HomeMarquee/HomeMarquee';
import { FeaturedCarousel } from '../FeaturedCarousel/FeaturedCarousel';
import { BackToTopButton } from '../BackToTopButton/BackToTopButton';
import { HomePageCarousel } from './HomePageCarousel';

const pagePlugins = [addPageScroll];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ComponentsMap: Record<ComponentTypesUnion, ComponentType<any>> = {
  [ComponentTypes.PageScroll]: PageScroll,
  [ComponentTypes.MainNav]: SideNav,
  [ComponentTypes.Marquee]: HomeMarquee,
  [ComponentTypes.Live]: HomePageCarousel,
  [ComponentTypes.Poster]: HomePageCarousel,
  [ComponentTypes.Featured]: FeaturedCarousel,
  [ComponentTypes.Standard]: HomePageCarousel,
  [ComponentTypes.ExtrasLogos]: HomePageCarousel,
  [ComponentTypes.BackToTopButton]: BackToTopButton,
  [ComponentTypes.MyShows]: HomePageCarousel,
};

export const layout = new LayoutComposer(ComponentsMap, pagePlugins);
